'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  DIRECT_PARTICIPATION: 'Direct Participation',
  FUND_FORMATION: 'Fund Formation',
  EARLY_STAGE: 'Start-up/Early Stage Growth',
  CONTROL_SALE: 'Control Sale (51% to 100%)',
  ASSET_ACQUISITION_DIVESTITURE: 'Asset Acquisition or Divestiture (A&D)',
  COMPANY_ACQUISITION_MERGER: 'Company Acquisition/Merger',
  COMPANY_ACQUISITION_DEVELOPMENT: 'Company Acquisition & Development',
  DEVELOPMENT: 'Development',
  RESTRUCTURING_RECAPITALIZATION: 'Restructuring/Recapitalization (Operations/Balance Sheet)',
  DISTRESSED_ACQUISITION_DIVESTITURE: 'Distressed Acquisition or Divestiture/Sale',
  FUND_INVESTMENT: 'Fund Investment'
});